import { createSliceForList } from "../helpers";

export const saleRecordSlice = createSliceForList({
  name: "saleRecord",
  reducers: {
    saleRecordFetched: (state, action) => {
      const { total, records } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.records = records;
      state.total = total;
    },
    refundMoneyToOriginFinished: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    refundMoneyToWalletFinished: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
  },
});
